<ng-content *ngIf="!(value === undefined || value === null)"> </ng-content>

<ng-template [ngIf]="value === undefined || value === null">
  {{ 'COMMON_SEARCH-NO_RESPONSE' | translate }}
</ng-template>
